import { render } from "./ArgonSnackbar.vue?vue&type=template&id=06f46ef6"
import script from "./ArgonSnackbar.vue?vue&type=script&lang=js"
export * from "./ArgonSnackbar.vue?vue&type=script&lang=js"

import "./ArgonSnackbar.vue?vue&type=style&index=0&id=06f46ef6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__